import React from 'react';
import { createRoot } from 'react-dom/client';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import App from './App';
import './styles/index.css';
import './styles/index.less';

SwiperCore.use([Pagination, Autoplay]);

const container = document.getElementById('root');
const root = createRoot(container as HTMLDivElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
